import script from "./log-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./log-info.vue?vue&type=script&lang=ts&setup=true"

import "./log-info.vue?vue&type=style&index=0&id=0fa621c1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa621c1"]])

export default __exports__